import { Spacing } from '@vkontakte/vkui';
import React from 'react';

import styles from './MultiTariffCardLoader.css';

const Placeholder = () => <div className={styles.placeholder} />;

export const MultiTariffCardLoader = () => {
    return (
        <div className={styles.root}>
            <div className={styles.card}>
                <div className={styles.spaceBlock}>
                    <div className={styles.space}>
                        <Placeholder />
                    </div>
                    <div className={styles.space}>
                        <Placeholder />
                    </div>
                    <div className={styles.space}>
                        <Placeholder />
                    </div>
                </div>

                <Spacing size={24} />

                <div className={styles.features}>
                    {Array.from(new Array(5)).map((_, idx) => (
                        <>
                            <div className={styles.feature} key={idx}>
                                <Placeholder />
                            </div>
                        </>
                    ))}
                </div>
            </div>

            <Spacing size={16} />
            <div className={styles.buttons}>
                <div className={styles.button}>
                    <Placeholder />
                </div>
                <div className={styles.button}>
                    <Placeholder />
                </div>
            </div>
        </div>
    );
};
